/** Backend users grid — FE column key → API sort_by. */

import { sortConfigToApiParams } from "./gridSortApiParams";

export const BACKEND_USERS_USE_SERVER_SORT = true;

export const BACKEND_USERS_API_SORT_FIELD = {
  first_name: "first_name",
  last_name: "last_name",
  email: "email",
  is_active: "is_active",
};

export function sortConfigToBackendUsersApiParams(
  sortConfig,
  enabled = BACKEND_USERS_USE_SERVER_SORT
) {
  return sortConfigToApiParams(sortConfig, BACKEND_USERS_API_SORT_FIELD, enabled);
}
